import styled from '@emotion/styled';
import { Trash } from '@phosphor-icons/react';
import { Trans } from '@lingui/macro';

import { colors } from 'styles/theme/colors';

type ClearFieldOptionProps = {
  handleClick?: (event: React.SyntheticEvent) => void;
};

export const ClearFieldOption = ({ handleClick }: ClearFieldOptionProps) => {
  return (
    <Container onClick={handleClick}>
      <Content>
        <Trash size={20} color={colors.error[400]} />
        <span>
          <Trans>Set empty</Trans>
        </span>
      </Content>
    </Container>
  );
};

/**
 * Class applied to the <li> wrapper so it spans full width and sticks
 * to the bottom of the dropdown listbox.
 */
export const CLEAR_OPTION_LI_CLASS = 'clear-field-option-li';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  width: 100%;
  cursor: pointer;
  color: ${p => p.theme.palette.text.error};
  font-family: ${p => p.theme.typography.bodySm.fontFamily};
  font-size: ${p => p.theme.typography.bodySm.fontSize};
  font-weight: ${p => p.theme.typography.bodySm.fontWeight};
  line-height: ${p => p.theme.typography.bodySm.lineHeight};
  border-top: 0.5px solid ${p => p.theme.palette.border?.primarySubtle ?? '#C0C0CE'};

  &:hover {
    opacity: 0.8;
  }
`;

const Content = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;
